/**
 * Pure new-password validation used by /auth/action's reset-password form.
 * Returns an i18n key on failure so the React layer can call `t(errorKey)`
 * to render the message — keeps this module string-table-free and testable.
 */

export const MIN_PASSWORD_LENGTH = 6;

export type PasswordValidationResult =
  | { ok: true }
  | { ok: false; errorKey: "passwordTooShort" | "passwordMismatch" };

export function validateNewPassword(
  newPassword: string,
  confirmPassword: string,
): PasswordValidationResult {
  if (newPassword.length < MIN_PASSWORD_LENGTH) {
    return { ok: false, errorKey: "passwordTooShort" };
  }
  if (newPassword !== confirmPassword) {
    return { ok: false, errorKey: "passwordMismatch" };
  }
  return { ok: true };
}
